import React, { useState } from 'react';
import './AlphaNum.css';

const alphabets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
const numbers = Array.from({ length: 10 }, (_, i) => i + 1);
const numbers10to20 = Array.from({ length: 11 }, (_, i) => i + 10);
const numbers20to30 = Array.from({ length: 11 }, (_, i) => i + 20);
const numbers30to40 = Array.from({ length: 11 }, (_, i) => i + 30);
const numbers40to50 = Array.from({ length: 11 }, (_, i) => i + 40);
const numbers50to60 = Array.from({ length: 11 }, (_, i) => i + 50);
const numbers60to70 = Array.from({ length: 11 }, (_, i) => i + 60);
const numbers70to80 = Array.from({ length: 11 }, (_, i) => i + 70);
const numbers80to90 = Array.from({ length: 11 }, (_, i) => i + 80);
const numbers90to100 = Array.from({ length: 11 }, (_, i) => i + 90);
const numbers100to150 = Array.from({ length: 51 }, (_, i) => i + 100);
const numbers150to200 = Array.from({ length: 51 }, (_, i) => i + 150);
const numbers10to1000 = Array.from({ length: 51 }, (_, i) => i * 10);
const numbers500to1000 = Array.from({ length: 11 }, (_, i) => i * 100);

const words = ['hello', 'world', 'react', 'javascript', 'coding', 'example', 'voice', 'select', 'option', 'button'];

 

const Alphabets = () => {
  const [mode, setMode] = useState('alphabets');
  const [selectedItem, setSelectedItem] = useState(null);
//   const[words, setWords]= useState('');

//   const numberToWords = (num) =>{
//     const zero=['Zero'];
//     const ones = [ '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen' ];
//      const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety']; 
    
//      if (num < 20) return ones[num];
//       if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 !== 0 ? ' ' + ones[num % 10] : ''); 
//       if (num < 1000) return ones[Math.floor(num / 100)] + ' Hundred ' + (num % 100 !== 0 ? numberToWords(num % 100) : '');
//       if (num < 1000000) return numberToWords(Math.floor(num / 1000)) + ' Thousand ' + (num % 1000 !== 0 ? numberToWords(num % 1000) : ''); return num; };
     



  const speak = (text) => {
    const msg = new SpeechSynthesisUtterance(text);
    window.speechSynthesis.speak(msg);
  };

  const handleClick = (item) => {
    speak(item);
    setSelectedItem(item);
    //setWords(numberToWords(parseInt(item, 10)));
  };

  const getImageSrc = (item) => {
    // Placeholder logic to generate image URL based on the item
    return `https://via.placeholder.com/150?text=${item}`;
  };

  return (
    <div className="AppAN">
      <h1> ALPHABETS</h1>
      <div className="select-container">
        <select onChange={(e) => setMode(e.target.value)} className="select">
          <option value="alphabets">Alphabets</option> 
         
          {/* <option value="words">Words</option> */}
        </select>
      </div>
      <div className="container">
         {mode === 'alphabets' && (
          <div className="alphabets">
            {alphabets.map((letter) => (
              <button key={letter} onClick={() => handleClick(letter)} className="button">
                {letter}
              </button>
            ))}
          </div>
        )} 

        {/* {mode === 'words' && (
          <div className="words">
            {words.map((word) => (
              <button key={word} onClick={() => handleClick(word)} className="button">
                {word}
              </button>
            ))}
          </div>
        )} */}
        {selectedItem && (
          <div className="three-d">
            {/* <img src={getImageSrc(selectedItem)} alt={selectedItem} /> */}
            {selectedItem}<br/>
            
          </div>
        )}
      </div>
    </div>
  );
};

export default Alphabets;
